import React from "react";

const Error = props => {
  return (
    <div
      style={{ color: "#C00", fontWeight: "bold", fontSize: "12px" }}
      className="error"
    >
      Error: {props.children}
    </div>
  );
};

export default Error;
